import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';

import AddTitleBar from '../titleBar/addTitleBar';

import { DateData } from '../formikInput/date';
import { MyInput, MyTextArea } from '../formikInput/input';

//Add-Product
import AddProduct from './addProduct';

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import VehicleDropdown from '../dropdowns/vendorVehicleDropdown';
import ConsigneeDropdown from '../dropdowns/consigneeDropdown'

//Actions
import { updateSalesOrder, getSalesOrder } from '../../redux/actions/salesOrderActions';
import { useState } from 'react';
import TitleBar from '../titleBar/titleBar';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import ConsignorDropdown from '../dropdowns/consignorDropdown';
import { LOCAL_STORAGE } from '../utils/constants';
import { dateFormats } from '../../utils/constant';

const EditSalesOrder = (props) => {
    const { updateSalesOrder, getSalesOrder, salesOrderDetails, salesOrderLoading } = props;

    const [branchData, setBranchData] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const [vendorDetails, setVendorDetails] = useState({});
    const [customerGst, setCustomerGst] = useState('');
    const [customerState, setCustomerState] = useState('');
    const [customerBranch, setCustomerBranch] = useState()
    const [branchStateMapId, setBranchStateMapId] = useState()
    const [customerbranchStateMapId, setCustomerBranchStateMapId] = useState()
    const [selectedBrannch, setSelectedBranch] = useState(null);
    const [isGstApplicable, setIsGstApplicable] = useState(true);
    const [msgToDisplay, setMsgToDisplay] = useState(null);
    const [branchGstNo, setBranchGstNo] = useState(null);

    useEffect(() => {
        const id = props.location.state.id;
        getSalesOrder('10', '', '1', id,)
    }, []);

    useEffect(() => {
        if (branchData && salesOrderDetails) {
            branchData.map((object) => {
                if (object.billingPartyBranchId == salesOrderDetails[0].client_branch_id) {
                    setCustomerBranch(object.billingPartyBranchCode)
                }
            })
        }
    }, [branchData, salesOrderDetails])

    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    const getBranchData = (childData) => {
        setBranchData(childData)
    };

    const getVehicleData = childData => {
        setVehicleData(childData);
    };

    const getVendorDetails = childData => {
        setVendorDetails(childData);
    };

    const cBranchChange = (isGSTExempted = null) => {
        if (isGSTExempted === 1) {
            setMsgToDisplay('Customer Branch is GST Exempted');
            return;
        }
        else {
            setMsgToDisplay(null);
            return;
        }
    };

    const isGSTApplicableOrNot = (isGSt, isRCM = null, isGSTExempted = null) => {
        if (isGSt === 0) {
            setMsgToDisplay('GST not applicable for branch');
            return;
        } else {
            if (salesOrderDetails[0].is_gst_exempted === 1) {
                setMsgToDisplay('Customer Branch is GST Exempted');
                return;
            }
            else if (isRCM === 'RCM') {
                setMsgToDisplay('Branch GST charge mechanism is RCM');
                return;
            }
            else if (isGSTExempted === 1) {
                setMsgToDisplay('Product is GST exempted');
                return;
            }
            else {
                setMsgToDisplay(null);
                return;
            }
        }
    };

    const getBranchStateMapId = (childData, data = null) => {
        const res = data?.options?.find((item) => { return item.value === data.value });
        if (res) {
            isGSTApplicableOrNot(res.isGSTApplicable, res.gstChargeMechanism);
            setBranchGstNo(res.gstNo)
        }
        else {
            setBranchGstNo(null)
        }
        setBranchStateMapId(childData);
    };

    const getBranchSelected = async (childData) => {
        const branchDetails = await branchData.find(data => data.billingPartyBranchCode === childData);
        if (branchDetails) {
            setSelectedBranch(branchDetails?.isGSTExempted === 1 ? `GST Exempted - ${branchDetails.GSTExemptedReasonName}` : null);
            cBranchChange(branchDetails?.isGSTExempted);
            setIsGstApplicable(branchDetails?.isGstApplicable === 1)
            setCustomerGst(branchDetails.billingPartyBranchGst);
            setCustomerState(branchDetails.state)
            setCustomerBranchStateMapId(branchDetails.billingPartyBranchStateId)
        }
    };

    if (salesOrderLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Edit Sales Order" LinkName="salesorder" />
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {
        getBranchSelected(salesOrderDetails && salesOrderDetails[0].client_branch_code)
        let soDetails = [];
        salesOrderDetails && salesOrderDetails[0].sales_orders_details.map((so, index) => {
            let temp = {}
            temp.productName = so.product_id
            temp.productCode = so.product_code
            temp.startDate = so.start_date ? new Date(so.start_date) : ''
            temp.endDate = so.end_date ? new Date(so.end_date) : ''
            temp.quantity = so.product_qty
            temp.rate = Math.trunc(so.product_price)
            temp.discount = Math.trunc(so.discount)
            temp.discountType = so.discount_type
            temp.iGstPercent = Math.trunc(so.igst_percentage)
            temp.iGst = ''
            temp.cGstPercent = Math.trunc(so.cgst_percentage)
            temp.cGst = ''
            temp.sGstPercent = Math.trunc(so.sgst_percentage)
            temp.sGst = ''
            temp.amount = ''
            soDetails[index] = { ...temp, ...salesOrderDetails[0] }
        })
        const salesData = salesOrderDetails ? salesOrderDetails[0] : null;
        //Formik
        const initialValues = {
            customerName: salesOrderDetails ? salesOrderDetails[0].client_code : '',
            consigneeName: salesOrderDetails ? salesOrderDetails[0].consignee_code : '',
            consignorName: salesOrderDetails ? salesOrderDetails[0].consignor_code : '',
            consigneeId: salesOrderDetails ? salesOrderDetails[0].consignee_id : '',
            consignorId: salesOrderDetails ? salesOrderDetails[0].consignor_id : '',
            customerBranch: salesOrderDetails ? salesOrderDetails[0].client_branch_name : customerBranch,
            branch: salesOrderDetails ? salesOrderDetails[0].branch_code : '',
            customerGst: customerGst,
            consigneeGst: customerGst,
            customerState: customerState,
            consigneeState: customerState,
            vehicle: salesOrderDetails ? salesOrderDetails[0].vehicle_number : '',
            salesOrderDate: salesOrderDetails ? new Date(salesOrderDetails[0].so_date) : '',
            lrNo: salesOrderDetails ? salesOrderDetails[0].lr_no : '',
            lrDate: salesOrderDetails?.[0]?.lr_date != null ? new Date(salesOrderDetails[0].lr_date) : null,
            tripMemoNo: salesOrderDetails ? salesOrderDetails[0].trip_memo_no : '',
            salesOrderNo: salesOrderDetails ? salesOrderDetails[0].so_number : '',
            refNo: salesOrderDetails ? salesOrderDetails[0].reference_number : '',
            remarks: salesOrderDetails ? salesOrderDetails[0].remarks : '',
            productDetails: soDetails ? soDetails
                :
                [{
                    productName: '',
                    startDate: '',
                    endDate: '',
                    quantity: 1,
                    rate: '',
                    discount: '',
                    discountType: "1",
                    iGstPercent: 0,
                    iGst: 0,
                    cGstPercent: '',
                    cGst: '',
                    sGstPercent: '',
                    sGst: 0,
                    amount: 0,
                }],
            finalAmount: '',
            adjustmentAmount: '',
            ...salesData
        };

        const validateSchema = yup.object().shape({
            customerName: yup.mixed().required('Vendor Name is Required'),
            customerBranch: yup.mixed().required('Branch is Required'),
            salesOrderDate: yup.mixed().required('Sales Order Date is Required'),
            productDetails: yup.array().of(
                yup.object().shape({
                    productName: yup.string().required("Add a product/service"),
                    quantity: yup.number("Should be a number").required("Quantity is required").min(1, "Should be more than 0"),
                    rate: yup.number("Should be a number").required("Rate is required").min(1, "Should be more than 1")
                })
            )
        })

        const onSubmit = (values, onSubmitProps) => {
            const psLineItems = [];
            values.productDetails.map((product, index) => {
                let temp = {}
                temp.product_code = product.productCode
                temp.start_date = product.startDate
                temp.end_date = product.endDate
                temp.product_qty = product.quantity
                temp.product_price = product.rate
                temp.product_amount = product.rate * product.quantity
                temp.igst_percentage = product.iGstPercent
                temp.igst_amount = product.iGst
                temp.cgst_percentage = product.cGstPercent
                temp.cgst_amount = product.cGst
                temp.sgst_percentage = product.sGstPercent
                temp.sgst_amount = product.sGst
                temp.tds_id = 9
                temp.tds_amount = 0
                temp.pending_tds_amount = 0
                temp.no_of_days = 0
                temp.discount = product.discount
                temp.final_discount = product.discount
                temp.discount_type = product.discountType
                temp.taxable_amount = product.rate * product.quantity - product.discount
                temp.total_amount = product.amount
                psLineItems[index] = { ...temp, ...product }
            });

            const updateSOData = {
                user_id: LOCAL_STORAGE.userId,
                customer_no: LOCAL_STORAGE.customerNo,
                client_code: values.customerName,
                consignee_code: values.consigneeName ? values.consigneeName : 0,
                consignor_code: values.consignorName,
                isGSTExempted: values.is_gst_exempted || 0,
                gstChargeMechanism: values.gst_charge_mechanism || null,
                branch_code: values.branch,
                client_branch_code: values.client_branch_code ? values.client_branch_code : salesOrderDetails[0]?.client_branch_code,
                so_date: moment(values.salesOrderDate).format(dateFormats.DD_MM_YYYY),
                reference_number: values.refNo,
                vehicle_no: values.vehicle,
                lr_no: values.lrNo,
                lr_date: values.lrDate ? moment(values.lrDate).format('DD-MM-YYYY') : null,
                trip_memo_no: values.tripMemoNo,
                taxable_amount: psLineItems.sum("taxable_amount"),
                so_quantity: psLineItems.length,
                so_amount: values.finalAmount,
                tds_amount: 0,
                sgst_amount: psLineItems.sum("sgst_amount"),
                cgst_amount: psLineItems.sum("cgst_amount"),
                igst_amount: psLineItems.sum("igst_amount"),
                remarks: values.remarks,
                total_order_amt: values.amount,
                adjustment: values.adjustmentAmount,
                gst_tax_type: 0,
                total_discount: psLineItems.sum("discount"),
                products: psLineItems,
            };

            updateSalesOrder(updateSOData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });
        };

        return (
            <React.Fragment>
                <AddTitleBar title="Edit Sales Order" LinkName="/salesorder" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}>
                        {({ touched, errors, values, isSubmitting, handleSubmit, }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" value={values.branch} getBranchStateMapId={getBranchStateMapId} />
                                                {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignor Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={ConsignorDropdown} name="consignorName"
                                                    value={values.consignorName}
                                                    consigneeMasterId={values.consignorId}
                                                />
                                                {touched.consignorName && errors.consignorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorName}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >

                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik
                                                    component={BillingPartyDropdown}
                                                    // disabled
                                                    name="customerName"
                                                    value={values.customerName}
                                                    placeholder="Customer Name"
                                                    getBranchData={getBranchData}
                                                    getVendorDetails={getVendorDetails}
                                                    getVehicleData={getVehicleData}
                                                    customerMasterCode={values.customerName}
                                                />
                                                {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignee Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik
                                                    component={ConsigneeDropdown}
                                                    name="consigneeName"
                                                    value={values.consigneeName}
                                                    consigneeMasterId={values.consigneeId}
                                                />
                                                {touched.consigneeName && errors.consigneeName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consigneeName}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            {values.customerName ?
                                                <>
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">Customer Branch</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="4">
                                                        <Fieldmik
                                                            className="w3-text-black"
                                                            component={CustomerBranchDropdown}
                                                            name="customerBranch"
                                                            salesOrderDetails={salesOrderDetails}
                                                            branchData={branchData}
                                                            getBranchSelected={getBranchSelected}
                                                            value={values?.client_branch_name ? values.client_branch_name : customerBranch ? customerBranch : ''}
                                                            setVendorDetails={setVendorDetails}
                                                            setBranchData={setBranchData}
                                                            placeholder={values?.client_branch_name ? values.client_branch_name : ''}
                                                        />
                                                        <span style={{ color: '#006837', fontWeight: 600, marginTop: '10px' }}>{selectedBrannch}</span>
                                                        {touched.customerBranch && errors.customerBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerBranch}</strong> : ''}
                                                    </FormUi.Field>
                                                </>
                                                :
                                                <FormUi.Field width="7" />
                                            }
                                            <FormUi.Field width="1" />

                                        </FormUi.Group>

                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer GST</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                {branchData?.[0]?.billingPartyBranchGst ? branchData[0].billingPartyBranchGst : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignee GST</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Branch GST</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                {branchGstNo}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer State</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                {branchData?.[0]?.state ? branchData[0].state : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Consignee State</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Vehicle Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={VehicleDropdown} name="vehicle" placeholder="Vehicle Number" value={values.vehicle} vehicleData={vehicleData} />
                                                {touched.vehicle && errors.vehicle ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicle}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Sales Order Date<span className='mandatory-star'> *</span></label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`salesOrderDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.salesOrderDate}
                                                    minDate={new Date()}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.salesOrderDate && errors.salesOrderDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.salesOrderDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">LR No.</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="lrNo" placeholder="LR Number" />
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">LR Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="3">
                                                <DateData
                                                    name={`lrDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.lrDate}
                                                    minDate={new Date()}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.lrDate && errors.lrDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.lrDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Trip Memo Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="tripMemoNo" placeholder="Trip Memo Number" />
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Remarks</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={MyTextArea} name="remarks" placeholder="Remarks" />
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                        </FormUi.Group>
                                    </div>
                                </Segment>
                                <Segment>
                                    <div className="ui form">
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Sales Order Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={MyInput} name="salesOrderNo" placeholder="Purchase Order Number" />
                                                {touched.salesOrderNo && errors.salesOrderNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.salesOrderNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Reference Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik component={MyInput} name="refNo" disabled />
                                                {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        {/* FieldArray Component */}
                                        <AddProduct masterState={branchStateMapId} vendorStateId={customerbranchStateMapId} isGstApplicable={msgToDisplay ? false : true} msgToDisplay={msgToDisplay} />
                                    </div>
                                </Segment>
                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = state => ({
    salesOrderDetails: state.getSalesOrderData.salesOrder.data,
    salesOrderLoading: state.getSalesOrderData.isLoading
})

export default connect(mapStatetoProps, { updateSalesOrder, getSalesOrder })(EditSalesOrder)
